import { render } from "./TokenModal.vue?vue&type=template&id=3373666a&scoped=true"
import script from "./TokenModal.vue?vue&type=script&lang=js"
export * from "./TokenModal.vue?vue&type=script&lang=js"

import "./TokenModal.vue?vue&type=style&index=0&id=3373666a&lang=scss&scoped=true"
import "./TokenModal.vue?vue&type=style&index=1&id=3373666a&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3373666a"]])

export default __exports__